/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
(function (angular) {
    'use strict';

    angular.module('app')
        .service('CommentsApi', CommentsApi);

    CommentsApi.$inject = [
        '$resource',
        'settings',
        'extendResource'
    ];

    function CommentsApi(
        $resource,
        settings,
        extendResource,
    ) {
        const resource = $resource(
            `${settings.apiBase}/comments/`, {
                itemId: '@itemId'
            }, {
                get: {
                    method: 'GET',
                    responseType: 'json',
                },
                create: {
                    method: 'POST',
                    responseType: 'json',
                },
                update: {
                    method: 'PUT',
                    responseType: 'json',
                    url: `${settings.apiBase}/comments/:itemId`,
                },
                delete: {
                    method: 'DELETE',
                    url: `${settings.apiBase}/comments/:itemId`,
                }
            }
        );

        return extendResource(resource);
    }
}(angular));
